// Purpose: Resolve the single public/private discovery setting for event UI and metadata.
// Features: Conservative legacy reads and paired compatibility fields on save.
// Dependencies: None; backend counterpart is functions/shared/event_visibility.js.
// Important behavior: Private is unlisted, not access-controlled; conflicting legacy flags stay private.

export const isEventPublic = (event = {}) => event?.publicSeo === true && event?.privateEvent !== true;

export const getEventVisibilityFields = (publicEvent) => ({
  publicSeo: publicEvent === true,
  privateEvent: publicEvent !== true,
});
